export default function generateArray(length: number): number[] {
  return Array.from({ length }, (_, index) => index + 1);
}
